module.exports = __webpack_public_path__ + "static/media/ECON.2730a9a4.png";